module.exports = __webpack_public_path__ + "img/profile.260a97f7.jpg";